<template>
  <div class="group-setup">
    <v-progress-linear indeterminate color="orange" v-if="loading"></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2">Project Member Contributions</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form class="pa-5" v-if="!loading">
        <v-row>
          <v-col cols="5" md="5" sm="12">
            <AutocompleteSearch @changeData="changeMembers($event)" :storeLink="'member/getAllMembersBySearch'"
              :setectVale="addData.member" :itemText="'name'"></AutocompleteSearch>
          </v-col>
          <v-col cols="5" md="5" sm="12">
            <v-text-field outlined dense v-model="addData.contributions" label="Contributions* (Rs.)"
              required></v-text-field>
          </v-col>
          <v-col cols="2" md="2" sm="12">
            <v-btn large color="green" depressed :disabled="loading || !addData.member || !addData.contributions
              " block @click="add()">Add</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <MemberContributionList :memberContributions="memberList" :project="project"
              @deleteContribution="deleteContribution($event)">
            </MemberContributionList>
          </v-col>
        </v-row>
      </v-form>

      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="3" xs="6">
            <v-btn large color="green" depressed :disabled="loading" block @click="previous()">Previous</v-btn>
          </v-col>
          <v-col cols="12" md="6" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn large color="green" depressed :disabled="loading" block @click="submit()">Next</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars :text="succesMsg" :snackbar="snackbar" :color="'success'" @classSnackbar="clossSnackbar" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { ProjectService } from "../../../../services/project-service.js";
import { checkError } from "@/config/errors.js";
import AutocompleteSearch from "@/components/shared/AutocompleteSearch";
import MemberContributionList from "../../view/child/MemberContributionList.vue";

export default {
  name: "groupSetUpFrom",
  props: ['uuid'],
  components: { Alert, Snackbars, AutocompleteSearch, MemberContributionList },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    succesMsg: "",

    addData: {
      member: null,
      contributions: null,
    },
    memberList: [],
    project: [],
  }),

  mounted() {
    this.getContributionList();
    this.getProjectInfo();
  },

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    submit() {
      this.$router.push({ name: 'ProjectEdit', params: { step: 4, uuid: this.uuid } })
    },

    previous() {
      this.$router.push({ name: 'ProjectEdit', params: { step: 2, uuid: this.uuid } })
    },

    getProjectInfo() {
      if (this.uuid !== null) {
        this.loading = true;
        ProjectService.getProjectInfo(this.uuid)
          .then((response) => {
            this.loading = false;
            this.form = [];
            if (response.data.data) {
              this.project = response.data.data;

            }
          })
          .catch((error) => {
            this.loading = false;
            this.project = [];
            if (error.response) {
              let data = error.response.data;
              let errorOutput = checkError.errorFormatting(data);
              this.errors = errorOutput;
            }
          });
      }
    },


    add() {
      if (this.uuid !== null) {
        this.errors = null;
        this.addData.project_id = this.uuid;
        ProjectService.createProjectClubContribution(this.addData)
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.getContributionList();
              this.getProjectInfo();
              this.reset();
            }
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    deleteContribution(uuid) {

      if (uuid !== null) {
        ProjectService.deleteProjectClubContribution(uuid)
          .then((response) => {
            this.loading = false;
            if (response.data.status_code === 200) {
              this.getContributionList();
              this.getProjectInfo();
            }
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    getContributionList() {
      this.loading = true;
      if (this.uuid !== null) {
        ProjectService.getProjectClubContribution(this.uuid)
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.memberList = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.memberList = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }

    },

    changeMembers(value) {
      this.addData.member = value;
    },

    onDismissed() {
      this.errors = null;
    },
    clossSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.addData.member = null;
      this.addData.contributions = null;
    },
  },
};
</script>
